import Vue from "vue";
import store from "@/store/store";
import { HOST } from "@/main";

// Set up the interceptor
export default function setupCsrfInterceptor() {
  Vue.http.interceptors.push((request, next) => {
    // Skip token check for the CSRF endpoint itself to avoid infinite loops
    if (request.url.includes("csrf/")) {
      next((response) => response);
      return;
    }
    const token = store.state.csrf_token || null;

    // Check if CSRF token exists
    if (token) {
      request.headers.set("X-CSRFToken", token);
    }

    next((response) => {
      if (response.status !== 403 || request._csrfRetried) {
        return response;
      }

      request._csrfRetried = true;

      return store
        .dispatch("fetchCsrfToken")
        .then(() => {
          request.headers.set("X-CSRFToken", store.state.csrf_token);
          return Vue.http(request);
        })
        .catch(() => response);
    });
  });
}
